import React from "react";
import HOC from "../../../components/HOC";
import AddRequestWarehouse from "../../../components/screen/centralWarehouse/request/AddRequestWarehouse";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";

const AddRequestTransferPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="New Request Transfer"
        mainComponent={<AddRequestWarehouse type={5} />}
        pageRole={38}
      />
    </div>
  );
};

export default HOC(AddRequestTransferPage);
